export interface IBase {
	id: number
	createdAt: string
	updatedAt: string
	deletedAt: string | null
}

export interface IBaseSeo {
	metaDescription: string
	metaKeywords: string
	metaTitle: string
	ogTitle: string
	ogDescription: string
	ogImage: IImage
}

export interface IBasePublishable extends IBase {
	isPublished: boolean
	publishedAt: string
}

export interface IBaseListMeta {
	currentPage: number
	from: number
	lastPage: number
	perPage: number
	to: number
	total: number
}

export interface IBaseListResponse<T> {
	data: T[] | []
	meta: IBaseListMeta
}

export interface IBaseResponse<T> {
	data: T | null
}

export interface IImage {
	url: string
	uuid: string
}

export enum SECTION_THEME_ENUM {
	MAN = 'man',
	WOMAN = 'woman',
	CHILD = 'child',
	SOLO = 'solo',
	FAMILY = 'family',
	HOLISTIC = 'holistic',
	ADULT = 'adult',
	DOCTORS = 'doctors',
	// NEW
	WHITE = 'white',
	SAND = 'sand',
	TIRQUOISE = 'tirquoise',
	BLUE = 'blue',
	FUCHSIA = 'fuchsia',
	PURPLE = 'purple',
	PURPLE_LIGHT = 'purple_light',
	CYCLAMEN = 'cyclamen',

	CYCLAMEN_LIGHT = 'cyclamen_light',
	NURSES = 'nurses',
	MANAGEMENT = 'managment'
}
